<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"> </p>
<p class="noindent"><a id="ch00_fm02_aut"></a><a id="page_ii"></a><span class="small">BOOK FIFTEEN</span>/ Louann Atkins Temple Women &amp; Culture Series /<br/><em>Books about women and families, and their changing role in society</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02_aut.vue?1b83d077